import {IGameFilterDefinition} from "../filters-definitions/game-filter-definition.interface";
import {BaccaratFilterDefinition} from "../filters-definitions/game-group/baccarat.filter-definition";
import {BlackjackFilterDefinition} from "../filters-definitions/game-group/blackjack.filter-definition";
import {CrapsFilterDefinition} from "../filters-definitions/game-group/craps.filter-definition";
import {KenoFilterDefinition} from "../filters-definitions/game-group/keno.filter-definition";
import {LiveEliteLungeFilterDefinition} from "../filters-definitions/game-group/live-elite-lunge.filter-definition";
import {
    LiveEliteLoungeOrExclusiveFilterDefinition
} from "../filters-definitions/game-group/live-elite-lounge-or-exclusive.filter-definition";
import {LiveGameShowsFilterDefinition} from "../filters-definitions/game-group/live-game-shows.filter-definition";
import {PokerFilterDefinition} from "../filters-definitions/game-group/poker.filter-definition";
import {RouletteFilterDefinition} from "../filters-definitions/game-group/roulette.filter-definition";
import {ScratchcardsFilterDefinition} from "../filters-definitions/game-group/scratchcards.filter-definition";
import {SlotsFilterDefinition} from "../filters-definitions/game-group/slots.filter-definition";
import {FilterCategoryDefinitionBase} from "./filter-category-definition-base";
import {CategoryDefinitionId} from "./filter-category-definition.interface";
import {OtherGameGroupFilterDefinition} from "../filters-definitions/game-group/other-game-group.filter-definition";
import {LiveBaccaratFilterDefinition} from "../filters-definitions/game-group/live-baccarat.filter-definition";
import {LiveBlackjackFilterDefinition} from "../filters-definitions/game-group/live-blackjack.filter-definition";
import {LivePokerFilterDefinition} from "../filters-definitions/game-group/live-poker.filter-definition";
import {LiveRouletteFilterDefinition} from "../filters-definitions/game-group/live-roulette.filter-definition";
import { ItalianTablesFilterDefinition } from "../filters-definitions/game-group/italian-tables.filter-definition";

export class GameGroupFiltersCategoryDefinition extends FilterCategoryDefinitionBase {

    get id(): CategoryDefinitionId {
        return 'gameGroups';
    }

    get title(): string{
        return this.services.translation.translate('GAME_CATEGORIES');
    }

    protected _loadAvailableFilters(): IGameFilterDefinition[] {
        const filters: IGameFilterDefinition[] = [
            new ItalianTablesFilterDefinition(this.services),
            new SlotsFilterDefinition(this.services),
            new RouletteFilterDefinition(this.services),
            new BlackjackFilterDefinition(this.services),
            new PokerFilterDefinition(this.services),
            new ScratchcardsFilterDefinition(this.services),
            new BaccaratFilterDefinition(this.services),
            new CrapsFilterDefinition(this.services),
            new KenoFilterDefinition(this.services),
            new LiveBaccaratFilterDefinition(this.services),
            new LiveBlackjackFilterDefinition(this.services),
            new LiveRouletteFilterDefinition(this.services),
            new LivePokerFilterDefinition(this.services),
            new LiveGameShowsFilterDefinition(this.services),
            new LiveEliteLungeFilterDefinition(this.services),
            new LiveEliteLoungeOrExclusiveFilterDefinition(this.services),
        ];
        return filters.concat(new OtherGameGroupFilterDefinition(this.services, filters));
    }


}